import { Action } from '@ngrx/store';
import { TMasterDataDatabases } from './master-data-db.reducer';

// Actions
export enum MasterDataActionTypes {
  LoadMasterData = '[MASTER_DATA_DB] Load BusinessContextItems',
  LoadFabricMasterData = '[MASTER_DATA_DB] Load Fabric Master Data',
  loadMasterDataByMasterList = '[MASTER_DATA_DB] Load Master Data By Master List',
  FailedMasterDataLoad = '[MASTER_DATA_DB][FAILED] Fetching BusinessContextItems from Cache',
  MasterDataLoaded = '[MASTER_DATA_DB] Normalized BusinessContextItems Loaded from Cache',
  RemoveMasterData = '[MASTER_DATA_DB] Remove Work Item',
}

export class LoadMasterData implements Action {
  readonly type = MasterDataActionTypes.LoadMasterData;
  constructor() {}
}

export class loadMasterDataByMasterList implements Action {
  readonly type = MasterDataActionTypes.loadMasterDataByMasterList;
  constructor(
    public masterList: string[],
    public updateSyncingStatus: boolean = false,
    public showLoader: boolean = true,
  ) {}
}

export class MasterDataLoaded implements Action {
  readonly type = MasterDataActionTypes.MasterDataLoaded;
  constructor(public payload: TMasterDataDatabases) {}
}

export class FailedMasterDataLoad implements Action {
  readonly type = MasterDataActionTypes.FailedMasterDataLoad;
  constructor() {}
}

export type TMasterDataActions = LoadMasterData | FailedMasterDataLoad | MasterDataLoaded | loadMasterDataByMasterList;
